import React from 'react';
import '../../styles/AuthForm.css';

export default function SigningIn({ email }) {
  return (
    <div className="auth-form">
      <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />

      <div className="auth-card signing-in-card">
        <h2 className="signing-title">Signing you in…</h2>

        <p className="signing-email">{email ? `Logging in as ${email}` : 'Please wait…'}</p>

        <div className="spinner-wrapper">
          <div className="spinner" />
        </div>
      </div>
    </div>
  );
}
